import CardPaymentsLogo from "../../images/swFeatureServices/card-payments-logo-en.png"
import CardPaymentsLogoWithSchemes from "../../images/swFeatureServices/card-payments-schemes-logo-en.png"
import CheckoutLogo from "../../images/swFeatureServices/checkout-logo.png"
import GoogleAnalyticsLogo from "../../images/swFeatureServices/g_analytics_logo.svg"
import AiiaLogo from "../../images/swPaymentTypes/account-to-account-aiia.svg"
import A2ALogo from "../../images/swPaymentTypes/account-to-account-en.png"
import AnydayLogo from "../../images/swPaymentTypes/anyday-logo.png"
import ApplePayLogo from "../../images/swPaymentTypes/applepay-dark-logo.svg"
import Area42Logo from "../../images/swPaymentTypes/area42-logo.svg"
import BancontactLogo from "../../images/swPaymentTypes/bancontact-logo.svg"
import IdealLogo from "../../images/swPaymentTypes/ideal-logo.svg"
import KlarnaLogo from "../../images/swPaymentTypes/klarna-logo.svg"
import MobilePayLogo from "../../images/swPaymentTypes/mobilepay-logo.svg"
import ResursLogo from "../../images/swPaymentTypes/resurs-logo.png"
import SwishLogo from "../../images/swPaymentTypes/swish-logo.png"
import TermsTechLogo from "../../images/swPaymentTypes/termstech-logo.svg"
import ViabillLogo from "../../images/swPaymentTypes/viabill-logo.png"
import VippsLogo from "../../images/swPaymentTypes/vipps-logo-text.svg"
import ITranslationImages from "../../type/ITranslationImages"

export const enImages: ITranslationImages = {
    images: {
        cardPaymentsLogo: CardPaymentsLogo,
        a2aLogo: A2ALogo,
        checkoutLogo: CheckoutLogo,
        cardPaymentsLogoWithSchemes: CardPaymentsLogoWithSchemes,
        viabillLogo: ViabillLogo,
        anydayLogo: AnydayLogo,
        klarnaLogo: KlarnaLogo,
        mobilepayLogo: MobilePayLogo,
        vippsLogo: VippsLogo,
        swishLogo: SwishLogo,
        applePayLogo: ApplePayLogo,
        poweredByAiiaLogo: AiiaLogo,
        resursLogo: ResursLogo,
        googleAnalyticsLogo: GoogleAnalyticsLogo,
        bancontactLogo: BancontactLogo,
        idealLogo: IdealLogo,
        termsTechLogo: TermsTechLogo,
        area42Logo: Area42Logo,
    },
}
